import { createGlobalStyle } from 'styled-components'
import { colors } from 'utils/colors'

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: Roboto, sans-serif;
    src: url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700');
  }

  @font-face {
    font-family: 'Roboto Condensed', sans-serif;
    src: url('https://fonts.googleapis.com/css?family=Roboto+Condensed:300,400,500,700');
  }

  @font-face {
    font-family: 'Noto Sans Thai', sans-serif;
    src: url('https://fonts.googleapis.com/css?family=Noto+Sans+Thai');
  }

  * {
    box-sizing: border-box;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    border: 0;
    font: inherit;
    font-size: 100%;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  html,
  body {
    height: 100vh;
    width: 100vw;
  }

  body {
    margin: 0;
    padding: 0;
  }

  html {
    color: ${colors.defaultText};
  }

  *,
  html,
  body {
    font-family: Roboto, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
  }

  :lang(th) {
    font-family: 'Noto Sans Thai', sans-serif;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote::before,
  blockquote::after,
  q::before,
  q::after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
    user-select: none;
  }

  input,
  button {
    :focus {
      outline: 0;
    }
  }

  input,
  textarea {
    text-overflow: ellipsis;
  }

  input[readonly],
  textarea[readonly] {
    cursor: default;
  }

  /* Remove autofill styles */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
  }

  /* disable incremental arrows for number-typed inputs */
  input[type='number'] {
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;
  }

  #root {
    height: 100%;
    box-sizing: border-box;
  }

  & ::-webkit-scrollbar {
    width: 1rem;
    height: 1rem;
  }

  & ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  & ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.gray3};
    border-radius: 1rem;
    border: 4px solid transparent;
    background-clip: content-box;
  }

  & ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.gray5};
  }
`

export default GlobalStyles
